import { render, staticRenderFns } from "./BackHeader.vue?vue&type=template&id=bc340100&"
import script from "./BackHeader.vue?vue&type=script&lang=js&"
export * from "./BackHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports